<template>
  <div class="order_home">
    <!-- <div class="index_title">
      <span class="back_icon" @click="goBack()"><van-icon name="arrow-left" /></span>
      <span>换机资料</span>
    </div> -->

    <div class="index_body">
      <div class="white_box">
        <div class="box_title">
          <div class="box_title">
            换机资料
          </div>
          <div class="title_line"></div>
        </div>

        <div class="flex ai_center jcsb" @click="bottomPopClick('brand_id')">
          <div>
            <van-field readonly v-model="formData.brand" label="手机品牌" input-align="right" placeholder="请选择手机品牌"
              class="custom-field" style="width: 108%;" />
          </div>

          <img class="arow" src="@/assets/images/unicom/arow.png" alt="">
        </div>
        <div class="flex ai_center jcsb" @click="bottomPopClick('model_id')">
          <div>
            <van-field readonly v-model="formData.model_name" label="手机型号" input-align="right" placeholder="请选择手机型号"
              class="custom-field" style="width: 108%;" />
          </div>
          <img class="arow" src="@/assets/images/unicom/arow.png" alt="">
        </div>
        <div class="flex ai_center jcsb" @click="bottomPopClick('ram_size')">
          <div>
            <van-field readonly v-model="formData.ram_size" label="手机规格" input-align="right" placeholder="请选择手机规格"
              class="custom-field" style="width: 108%;" />
          </div>
          <img class="arow" src="@/assets/images/unicom/arow.png" alt="">
        </div>

        <div>
          <van-field v-model="formData.imei" label="新机IMEI" placeholder="请输入新机IMEI" input-align="right"
            class="custom-field" />
        </div>
        <div>
          <van-field v-model="formData.old_imei" label="旧机IMEI" placeholder="请输入旧机IMEI" input-align="right"
            class="custom-field" />
        </div>
        <div>
          <van-field v-model="new_price" @input="handlePriceInput" type="number" label="新机裸机价" placeholder="请输入新机裸机价"
            input-align="right" class="custom-field" />
        </div>
        <div class="van-field-simulate">
          <div class="van-field-simulate-label">补交金额</div>
          <div class="van-field-simulate-value">￥{{ formData.money || 0 }}</div>
        </div>
        <div class="van-field-simulate">
          <div class="van-field-simulate-label">理赔金额</div>
          <div class="van-field-simulate-value">￥{{ formData.claims_money || 0 }}</div>
        </div>
      </div>

      <div class="white_box">
        <div class="box_title">
          <div class="box_title">
            收款信息
          </div>
          <div class="title_line"></div>
        </div>

        <div>
          <van-field v-model="formData.payment_name" label="收款名称" placeholder="请输入收款名称" input-align="right"
            class="custom-field" />
        </div>
        <div>
          <van-field v-model="formData.payment_acc" label="收款账号" placeholder="请输入收款账号" input-align="right"
            class="custom-field" />
        </div>
        <div class="van-field-simulate">
          <div class="van-field-simulate-label">收款类型</div>
          <div class="flex flex_center">
            <img src="../../assets/images/unicom/zfb_icn.png" style="height: 16px;width: 16px;margin: 3px;">
            支付宝
          </div>
        </div>
      </div>

      <div class="white_box">
        <div class="box_title">
          <div class="box_title">
            取件信息
          </div>
          <div class="title_line"></div>
        </div>

        <div>
          <van-field v-model="formData.send_name" label="取件名称" placeholder="请输入取件名称" input-align="right"
            class="custom-field" />
        </div>
        <div>
          <van-field v-model="formData.send_phone" label="取件电话" placeholder="请输入取件电话" input-align="right"
            class="custom-field" />
        </div>
        <div class="flex ai_center" style='width: 100%;'>
          <liantAddress title="取件地址" v-model="formData.send_gps"></liantAddress>
        </div>
        <div>
          <van-field style="padding-top: 0;line-height: 30px;" rows="1" autosize type="textarea"
            v-model="formData.send_address" label="详细地址" placeholder="请输入详细地址" input-align="right" />
        </div>
      </div>

      <div class="white_box">
        <div class="box_title">
          <div class="box_title">
            换机完成照片
          </div>
          <div class="title_line"></div>
        </div>
        <UnicomPicUploader :example="'https://img.fanxinghuishou.cn/20260324/728567157.png'"
          @change="(url) => (formData.tem_img = url)" :src="formData.tem_img" :title="''">
        </UnicomPicUploader>
      </div>

      <div class="white_box">
        <div class="box_title flex jcsb">
          <div>
            <div class="box_title ">
              申请换机
            </div>
            <div class="title_line"></div>
          </div>

          <div @click="claimMoedelShow = !claimMoedelShow" class="shou flex flex_center">收起信息
            <img v-if="claimMoedelShow" src="../../assets/images/unicom/arrow_down.png"
              style="width: 12px;height: 6px;margin-left: 3px;" alt="">
            <img v-if="!claimMoedelShow" src="../../assets/images/unicom/arrow_up.png"
              style="width: 12px;height: 6px;margin-left: 3px;" alt="">
          </div>
        </div>

        <div v-if="claimMoedelShow">
          <div>
            <van-field v-model="claimData.name" label="名称" readonly placeholder="--" input-align="right"
              class="custom-field" />
          </div>
          <div>
            <van-field v-model="claimData.phone" label="手机号" readonly placeholder="--" input-align="right"
              class="custom-field" />
          </div>
          <div>
            <van-field v-model="claimData.id_card" label="身份证号" readonly placeholder="--" input-align="right"
              class="custom-field" />
          </div>
          <div>
            <van-field v-model="claimData.imei" label="IMEI" readonly placeholder="--" input-align="right"
              class="custom-field" />
          </div>
          <div class="flex ai_center ">
            <van-field v-model="claimData.brand" label="手机品牌" readonly input-align="right" placeholder="--"
              class="custom-field" />
          </div>
          <div class="flex ai_center">
            <van-field v-model="claimData.model_name" label="手机型号" readonly input-align="right" placeholder="--"
              class="custom-field" />
          </div>
          <div class="flex ai_center">
            <van-field v-model="claimData.ram_size" label="手机规格" readonly input-align="right" placeholder="--"
              class="custom-field" />
          </div>
          <div>
            <van-field v-model="claimData.insure_san" label="产品名称" readonly placeholder="--" input-align="right"
              class="custom-field" />
          </div>
          <div class="van-field-simulate">
            <div class="van-field-simulate-label">保值金额</div>
            <div class="van-field-simulate-value">￥{{ claimData.claims_money || 0 }}</div>
          </div>
          <!-- <div class="flex ai_center">
            <van-field readonly v-model="claimData.damage_title" label="手机故障" input-align="right" placeholder="--"
              class="custom-field" />
          </div> -->
        </div>
      </div>

      <div class="white_box">
        <div class="flex jcsb">
          <div class="box_title">

            <div class="box_title">
              申请照片
            </div>
            <div class="title_line"></div>
          </div>
          <div @click="imgMoedelShow = !imgMoedelShow" class="shou flex flex_center">收起信息
            <img v-if="imgMoedelShow" src="../../assets/images/unicom/arrow_down.png"
              style="width: 12px;height: 6px;margin-left: 3px;" alt="">
            <img v-if="!imgMoedelShow" src="../../assets/images/unicom/arrow_up.png"
              style="width: 12px;height: 6px;margin-left: 3px;" alt="">
          </div>
        </div>
        <div v-if="imgMoedelShow">
          <img v-if="claimData.imgs" :src="claimData.imgs[0]" @click="imgShow = true" alt="" class="cla_img">

        </div>
      </div>

      <div class="m_t_40">
        <div class="btn btn-top ">
          <van-button color="#577BB5" size="large" @click='submit()'>确认提交</van-button>
        </div>
      </div>
    </div>

    <van-overlay :show="imgShow" @click="imgShow = false" z-index="100">
      <van-swipe v-if="imgShow && claimData.imgs && claimData.imgs.length > 0" class="my-swipe" :autoplay="3000"
        indicator-color="white" :touchable="true">
        <van-swipe-item v-for="(item, ind) in claimData.imgs" :key="ind">
          <img :src="item" alt="" style="height: 300px;width: 260px;">
        </van-swipe-item>

      </van-swipe>
    </van-overlay>

    <van-popup v-model="phoneTypeBottom" position="bottom" closeable round>
      <div class="flex flex_center phone_title">{{ phoneTypeTitle }}</div>
      <div class="phone_type_box">
        <div @click="phoneTypeClick(item.id, item.name, ind)" v-for="(item, ind) in bottomTypeList" :key="ind"
          :class="item.isClick ? 'flex flex_center phone_type_item click_phone_item' : 'flex flex_center phone_type_item'">
          <div>{{ item.name }}</div>
        </div>
      </div>
    </van-popup>

  </div>
</template>

<script>
import {
  getPhoneBrand, getPhoneModel, getPhoneRam, setOrderClaims,
  getClaims, setPlanes
} from "@/api/unicom";

import liantAddress from "../../components/cell/GetAddressliant/index.vue"

import { Swipe, SwipeItem, Overlay } from 'vant';

export default {
  name: "orderhome",
  components: {
    VanSwipe: Swipe,
    VanSwipeItem: SwipeItem,
    VanOverlay: Overlay,
    liantAddress,
  },
  data() {
    return {
      form: {
        address: '',
      },
      formaddress: '',
      map: null,
      placePicker: null,
      selectedAddress: '',
      selectedLocation: null,
      formData: {
      },
      bottomType: 'brand_id',
      bottomTypeList: [],
      brandList: [],
      modelList: [],
      ramList: [],
      phoneTypeBottom: false,
      phoneTypeTitle: '',
      claimData: {},
      finish_brand_id: '',
      finish_model_id: '',
      imgMoedelShow: false,
      claimMoedelShow: false,
      imgShow: false,
      new_price: 0,
      allAddress: '',
      pname: '',
      cityname: "",
      adname: '',
    }
  },
  watch: {
    adressall(newVal, oldVal) {
      console.log(newVal);
    },
    new_price(value) {
      console.log('new_price', value);
      this.formData.money = value - this.formData.claims_money
      if (this.formData.money < 0) {
        this.formData.money = 0
      }
    }

  },
  computed: {
    adressall() {
      return this.$store.state.adressall
    }
  },
  beforeDestroy() {
    console.log("qingchu清楚");
  },

  mounted() {
    const { claims_id, finish_id } = this.$route.query
    getClaims({ claims_id })
      .then((res) => {
        const { finish, claims } = res.data
        this.formData = finish
        this.claimData = claims
        const { brand_id, model_id, new_price } = finish
        console.log('brand_idbrand_id', brand_id);
        this.new_price = new_price
        this.finish_brand_id = brand_id
        this.finish_model_id = model_id
        console.log(this.$store.state, 'finish_idfinish_id', finish_id);
        if (this.$store.state.adressall.name) {
          console.log("选择了地址000000");
          let { pname, cityname, adname, address, name } = this.$store.state.adressall
          this.pname = pname
          this.cityname = cityname
          this.adname = adname
          this.formData.send_gps = pname + cityname + adname
          this.formData.send_address = address // name
        }
      })
      .catch((err) => {
        // this.$toast((err && err.msg) || "获取数据失败");
      });

    setTimeout(() => {
      getPhoneBrand().then((res) => {
        const { brandList } = res.data
        this.brandList = brandList ? brandList.map((le) => {
          return {
            name: le.brand,
            id: le.brand_id,
            isClick: false
          }
        }) : []

        this.formData.brand = this.brandList.find((le => le.id == this.finish_brand_id)).name
        this.phoneTypeTitle = '选择手机品牌'
        this.bottomTypeList = this.brandList
      })
        .catch((err) => {
          // this.$toast((err && err.msg) || "获取数据失败");
        });
      getPhoneModel({ brand_id: this.finish_brand_id })
        .then((res) => {
          this.modelList = res.data ? res.data.map((le) => {
            return {
              name: le.model_name,
              id: le.model_id,
              isClick: false
            }
          }) : []
          this.formData.model_name = this.modelList.find((le => le.id == this.finish_model_id)).name

        })
        .catch((err) => {
          // this.$toast((err && err.msg) || "获取数据失败");
        });
    }, 600);

  },
  methods: {
    // 实时限制输入格式，确保小数点后最多两位
    handlePriceInput(value) {
      // 正则表达式：允许数字和最多两位小数
      const reg = /^\d*\.?\d{0,2}$/;

      if (!reg.test(value)) {
        // 截取符合规则的部分
        const match = value.match(/^\d*\.?\d{0,2}/);
        this.new_price = match ? match[0] : '';
      } else {
        this.new_price = value;
      }
    },

    getFormattedAddress(value) {
      console.log('getFormattedAddress', value);
      this.allAddress = value
    },
    goBack() {
      this.$router.go(-1)
    },
    bottomPopClick(type) {
      this.bottomType = type
      if (type == 'brand_id') {
        this.phoneTypeTitle = '选择手机品牌'
        this.bottomTypeList = this.brandList
      } else if (type == 'model_id') {
        if (this.modelList.length == 0) {
          this.$toast(("请先选择手机品牌"));
          return
        }
        this.phoneTypeTitle = '选择手机型号'
        this.bottomTypeList = this.modelList
      } else if (type == 'ram_size') {
        if (this.modelList.length == 0 || this.ramList.length == 0) {
          this.$toast(("请先选择手机型号"));
          return
        }
        this.phoneTypeTitle = '选择手机规格'
        this.bottomTypeList = this.ramList
      }
      this.phoneTypeBottom = true
    },

    phoneTypeClick(id, name, index) {
      if (this.bottomType == 'brand_id') {
         if(this.formData.brand_id && this.formData.brand_id === id){
          this.phoneTypeBottom = false
          return
        }
        this.formData.brand_id = id
        this.formData.brand = name
        this.formData.model_id = ""
        this.formData.model_name = ""
        this.formData.ram_size = ""
        this.modelList = []
        this.ramList = []
        const { order_id } = this.formData
        console.log(111);
        getPhoneModel({ brand_id: id })
          .then((res) => {
            this.modelList = res.data ? res.data.map((le) => {
              return {
                name: le.model_name,
                id: le.model_id,
                isClick: false
              }
            }) : []
            this.phoneTypeBottom = false
          })
          .catch((err) => {
            // this.$toast((err && err.msg) || "获取数据失败");
          });
      } else if (this.bottomType == 'model_id') {
        if(this.formData.model_id && this.formData.model_id === id){
          this.phoneTypeBottom = false
          return
        }
        this.formData.model_id = id
        this.formData.model_name = name
        this.formData.ram_size = ""
        this.ramList = []
        getPhoneRam({ model_id: id })
          .then((res) => {
            this.ramList = res.data ? res.data.map((le) => {
              return {
                name: le.ram_size,
                id: le.ram_size,
                isClick: false
              }
            }) : []
            this.phoneTypeBottom = false
          })
          .catch((err) => {
            // this.$toast((err && err.msg) || "获取数据失败");
          });
      } else if (this.bottomType == 'ram_size') {
        this.formData.ram_size = id
        this.phoneTypeBottom = false
      }

    },


    submit() {
      const { claims_id } = this.claimData
      // const addressList = this.allAddress ? this.allAddress.split(',') : []
      // console.log(addressList, 'addressListaddressList');

      setPlanes({
        ...this.formData,
        province: this.pname,
        city: this.cityname,
        district: this.adname,
        new_price: this.new_price,
        claims_id
      })
        .then((res) => {
          // 存储状态
          sessionStorage.setItem('activeTab', '02')
          this.$router.go(-1)
          this.$toast((res && res.msg) || "提交成功");
        })
        .catch((err) => {
          this.$toast((err && err.msg) || "提交失败");
        });
    },


  },
}
</script>

<style lang="less" scoped>
.my-swipe .van-swipe-item {
  margin-top: 300px;
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
}

/* 如果你要改整个 van-field 的高度 */
/deep/ .custom-field {
  height: 90px !important;
  border-bottom: none !important;
}

/* 模拟 vant 只读 van-field 样式 */
.van-field-simulate {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  font-size: 29px;
  line-height: 1.5;
  margin-top: 30px;
  margin-right: 22px;
}

/* 左边 label */
.van-field-simulate-label {
  color: #666;
  margin-right: 12px;
  margin-left: 25px;
}

/* 右边 value（只读样式） */
.van-field-simulate-value {
  flex: 1;
  text-align: right;
  color: #FF4133;
}

.flex {
  display: flex;
}

.flex_center {
  justify-content: center;
  align-items: center;
}

.jcsb {
  justify-content: space-between;
}

.ai_center {
  align-items: center;
}

.hei_90 {
  height: 90px;
}

.ai_end {
  align-items: flex-end;
}

.mar_t_35 {
  margin-top: 35px;
}

.m_t_40 {
  margin-top: 40px;
}

.phone_title {
  height: 115px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 32px;
  color: #333333;
  line-height: 44px;
  text-align: center;
  font-style: normal;
}

.phone_type_box {
  height: 600px;
  overflow-y: scroll;
}

.phone_type_item {
  height: 88px;
  border-radius: 16px;
  padding: 25px 0;
  margin: 20px 30px;
}

.click_phone_item {
  background: rgba(87, 123, 181, 0.12);
  color: #577BB5;
}

.flex_wrap {
  display: flex;
  flex-wrap: wrap;
  /* 自动换行 */
  gap: 20px;
  /* 每个之间的间距（可改） */
  margin-left: 25px;
}



.btn {
  width: calc(100vw - 120px);
  margin: auto;
  margin-bottom: 35px;

  button {
    height: 88px;
  }
}

.btn-top {
  button {
    box-shadow: 0px 6px 15px 1px rgba(87, 123, 181, 0.4);
  }
}

.btn-bottom {
  button {
    box-shadow: 0px 6px 15px 1px rgba(87, 123, 181, 0.1);
    color: #577BB5 !important;
  }
}

.order_home {
  background-color: #F7F8FA;
  position: fixed; // 父容器固定布局，占满整个窗口
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 0; // 移除原padding，避免高度计算偏差

  // min-height: 2000px;
  .index_title {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10; // 确保底部栏在最上层
    width: 100%;
    height: 160px;
    display: flex;
    align-items: center;
    background: #EDEDED;
    font-weight: 500;
    font-size: 32px;
    color: #1D1E20;
    padding: 0 25px;

    .back_icon {
      width: 42%;
    }
  }

  // 核心：填充剩余高度 + 内部滚动
  .index_body {
    position: absolute;
    top: 20px;
    left: 0;
    width: 100%;
    // 计算高度：窗口高度 - 底部栏高度（152px为底部栏总高度）
    height: calc(100% - 30px);
    overflow-y: auto; // 内容超出时内部滚动
    // margin-top: 130px;
    padding: 0 25px;
  }

  .white_box {
    background: #FFFFFF;
    border-radius: 16px;
    padding: 30px 25px;
    margin-top: 30px;

    .box_title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 32px;
      color: #333333;
      line-height: 44px;
      text-align: left;
      font-style: normal;

      .title_line {
        width: 131px;
        height: 8px;
        background: #577BB5;
        opacity: 0.4;
        margin-top: -11px;
      }
    }

    .shou {
      font-weight: 400;
      font-size: 24px;
      color: #577BB5;
    }

    .arow {
      height: 16px;
      width: 16px;
      margin-top: 50px;
    }

    .cla_img {
      width: 312px;
      height: 312px;
      border-radius: 16px;
      margin: 30px 0;
    }
  }
}
</style>
